// import apolloClient from './../apolloClient.js'

const state = {
  showModal: false,
  editCity: null,
  editCompany: null,
  editTechcenter: null,
  editVirtualNumber: null,
  editInternalNumber: null,
  editRole: null
}

const mutations = {
  SET_ADMIN_MODAL (state, value) {
    state.showModal = value
  },
  SET_ADMIN_EDIT_CITY (state, value) {
    state.editCity = value
  },
  SET_ADMIN_EDIT_COMPANY (state, value) {
    state.editCompany = value
  },
  SET_ADMIN_EDIT_TECHCENTER (state, value) {
    state.editTechcenter = value
  },
  SET_ADMIN_EDIT_VIRTUAL_NUMBER (state, value) {
    state.editVirtualNumber = value
  },
  SET_ADMIN_EDIT_INTERNAL_NUMBER (state, value) {
    state.editInternalNumber = value
  },
  SET_ADMIN_EDIT_ROLE (state, value) {
    state.editRole = value
  }
}

const actions = {
  setAdminModal: ({commit}, value) => {
    commit('SET_ADMIN_MODAL', value)
  }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/adminStore.js